import {Head} from '@aboutyou/head-elements';
import {useWishlistRoute} from '@aboutyou/router';
import React from 'react';
import {AUTO_ADD_TO_WISHLIST_PARAM} from '../../backend-services/Wishlist/hooks/useAutoAddToWishlist';

function addToWishlistRedirectScript(
  wishlistRoute: string,
  productId: number,
  addToWishlistParam: string,
) {
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.get(addToWishlistParam) !== '1') {
    return;
  }

  urlParams.set(addToWishlistParam, String(productId));

  window.location.replace(
    `${window.location.origin}${wishlistRoute}?${urlParams.toString()}`,
  );
}

export const AddToWishlistRedirect: React.FC<{productId: number}> = ({
  productId,
}) => {
  const wishlistRoute = useWishlistRoute();

  return (
    <Head>
      <script id="a2w-redirect">{`(${addToWishlistRedirectScript.toString()})("${wishlistRoute}", ${productId}, "${AUTO_ADD_TO_WISHLIST_PARAM}")`}</script>
    </Head>
  );
};
